var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsOptional, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { WeeklyWindowDto } from './weekly-window.dto.js';
import { SpecificBlockDto } from './specific-block.dto.js';
export class PatientAvailabilityDto {
    weeklyWindows;
    specificBlocks;
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => WeeklyWindowDto),
    IsOptional(),
    __metadata("design:type", Array)
], PatientAvailabilityDto.prototype, "weeklyWindows", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SpecificBlockDto),
    IsOptional(),
    __metadata("design:type", Array)
], PatientAvailabilityDto.prototype, "specificBlocks", void 0);
//# sourceMappingURL=patient-availability.dto.js.map